const hi = {
  home: {
    hero: {
      alt: 'पंच तत्व लोगो',
      tagline: 'संतुलन, उपस्थिति और पाँच तत्वों की एक शांत खोज।',
      cta: 'तत्वों में प्रवेश करें',
    },
    collection: {
      title: 'तत्व',
      description:
        'प्रत्येक तत्व एक अस्तित्व की अवस्था को दर्शाता है — रूप, बनावट और उद्देश्य के माध्यम से अभिव्यक्त।',
    },
    about: {
      title: 'हमारा दर्शन',
      paragraphs: [
        'पंच तत्व एक दर्शन है जो इस समझ पर आधारित है कि संतुलन बनाया नहीं जाता — इसे याद किया जाता है।',
        'तत्व जागरूकता और सचेत रचना के माध्यम से यह दर्शाता है कि कैसे रोज़मर्रा की वस्तुएँ आधुनिक जीवन में उपस्थिति, ताल और शांत सामंजस्य का समर्थन कर सकती हैं।',
      ],
    },
  },
  nav: {
    home: 'होम',
    shop: 'दुकान',
    about: 'हमारे बारे में',
    cart: 'कार्ट',
    logoAlt: 'Anukta द्वारा पंच तत्व लोगो',
  },
  footer: {
    brand: 'Panch Tatva',
    tagline: 'सावधान रचनाओं के माध्यम से तत्वों के संतुलन की एक दर्शन।',
    explore: ['होम', 'तत्व', 'दर्शन', 'अनुष्ठान', 'दुकान'],
    exploreTitle: 'खोज',
    contact: {
      email: 'support@panch-tatva.co.in',
      phone: '+91 6390725752',
    },
    contactTitle: 'संपर्क',
    legal: [
      '“Panch Tatva by Anukta” एक ब्रांड और दर्शन है जिसे Anukta Panchatatva LLP द्वारा संचालित किया जाता है।',
      '© 2026 Panch Tatva by Anukta™. सर्वाधिकार सुरक्षित।',
    ],
  },
  card: {
    addToCart: 'कार्ट में जोड़ें',
    viewDetails: 'विवरण देखें',
  },
  cart: {
    title: 'आपका कार्ट',
    empty: 'आपका कार्ट खाली है',
    remove: 'हटाएँ',
    totalPrefix: 'कुल:',
    checkout: 'चेकआउट',
    guestBanner: 'अपनी कार्ट सभी डिवाइस पर सहेजने के लिए साइन इन करें', // TODO: professional translation
  },
  checkout: {
    guestSignInPrompt: 'तेज़ चेकआउट के लिए साइन इन करें', // TODO: professional translation
    // Address section
    shippingAddress: 'शिपिंग पता',
    savedAddresses: 'सहेजे गए पते',
    addNewAddress: '+ नया पता जोड़ें',
    useThisAddress: 'इस पते का उपयोग करें',
    noSavedAddresses: 'कोई सहेजा हुआ पता नहीं मिला',
    loadingAddresses: 'आपके पते लोड हो रहे हैं…',
    addressLoadError: 'सहेजे हुए पते लोड नहीं हो सके। कृपया मैन्युअल रूप से दर्ज करें।',
    // Address form fields
    fullName: 'पूरा नाम',
    phone: 'फ़ोन नंबर',
    email: 'ईमेल',
    addressLine: 'पता',
    city: 'शहर',
    state: 'राज्य',
    pincode: 'पिनकोड',
    saveAsDefault: 'डिफ़ॉल्ट पते के रूप में सहेजें',
    // Shipping options section
    deliveryMethod: 'डिलीवरी विधि',
    fetchingRates: 'शिपिंग दरें प्राप्त की जा रही हैं…',
    shippingRatesFor: 'दरें:',
    noShippingOptions: 'इस पिनकोड के लिए कोई कूरियर सेवा उपलब्ध नहीं है। कृपया पिनकोड जाँचें।',
    shippingFallback: 'लाइव दरें उपलब्ध नहीं — मानक विकल्प दिखाए जा रहे हैं।',
    shippingApiError: 'शिपिंग दरें लोड नहीं हो सकीं। मानक विकल्प उपयोग किए जा रहे हैं।',
    ratesUpdating: 'दरें अपडेट हो रही हैं…',
    pincodeMissing: 'शिपिंग दरें लोड करने के लिए एक वैध पिनकोड दर्ज करें।',
    deliveryDays: 'कार्य दिवस',
    standardDelivery: 'मानक डिलीवरी',
    standardDays: '3–5 कार्य दिवस',
    expressDelivery: 'एक्सप्रेस डिलीवरी',
    expressDays: '1–2 कार्य दिवस',
    reviewOrder: 'ऑर्डर की समीक्षा करें',
    deliveryTo: 'डिलीवरी:',
    continue: 'जारी रखें',
    back: 'वापस',
    payNow: 'भुगतान करें',
    stepAddress: 'पता',
    stepShipping: 'शिपिंग',
    stepReview: 'समीक्षा',
    cartEmpty: 'आपका कार्ट खाली है',
    cartEmptyDesc: 'चेकआउट से पहले आइटम जोड़ें',
    continueShopping: 'खरीदारी जारी रखें',
    // v2.7 — Feature 33 // TODO: professional translation
    noCoverage: 'इस पिनकोड पर डिलीवरी उपलब्ध नहीं है।',
    noCoverageDesc: 'कृपया पिनकोड जाँचें या हमसे संपर्क करें।',
    editAddress: 'पता संपादित करें',
    serviceUnavailable: 'डिलीवरी विकल्प अभी उपलब्ध नहीं हैं। मानक विकल्प दिखाए जा रहे हैं।',
    retryRates: 'पुनः प्रयास करें',
    recommended: 'अनुशंसित',
  },
  auth: {
    loading: 'लोड हो रहा है...',
    greeting: 'नमस्ते',
    login: 'लॉगिन',
    logout: 'लॉगआउट',
    anonymous: 'उपयोगकर्ता',
  },
  payment: {
    payPrefix: 'भुगतान',
    verifySuccess: 'भुगतान सत्यापित और सफल!',
    verifyFail: 'भुगतान सत्यापन विफल हुआ। कृपया समर्थन से संपर्क करें।',
    verifyError: 'भुगतान सत्यापन त्रुटि।',
    initiationFail: 'भुगतान आरंभ करने में विफल।',
  },
  product: {
    notFound: 'उत्पाद नहीं मिला',
  },
  authPages: {
    loginHeader: 'जारी रखने के लिए लॉगिन करें',
    loginPrompt: 'कृपया भुगतान जारी रखने के लिए लॉगिन करें।',
  },
  shop: {
    title: 'सभी उत्पाद',
  },
  products: {
    '1': {
      name: 'पृथ्वी',
      description: 'प्राकृतिक मिट्टियों और जड़ी-बूटियों से निर्मित ग्राउंडिंग और पोषण देने वाले उत्पाद, माता पृथ्वी की प्रज्ञा से प्रेरित।',
    },
    '2': {
      name: 'पानी',
      description: 'समझौतों को शांत करने के लिए जलीय सुगंधों और आवश्यक तेलों से मिश्रित सुखदायक उत्पाद।',
    },
    '3': {
      name: 'अग्नि',
      description: 'उत्साह बढ़ाने वाले उत्पाद जो अपने स्थान में जीवंतता और ऊर्ज़ा भरते हैं।',
    },
    '4': {
      name: 'वायु',
      description: 'वायु से प्रेरित रचनाएँ, सूक्ष्म सुगंध छोड़ती हैं क्योंकि प्रेरणा स्वतंत्र रूप से मूव करती है और रास्ते खुलते हैं।',
    },
    '5': {
      name: 'ऐथर',
      description: 'नरम शुद्धि के लिए बनाए गए — स्पष्टता, असीमित अन्तरिक्ष और एक मौन उपस्थिति को शांत विलासिता में आमंत्रित करते हैं।',
    },
    '6': {
      name: 'Panch Tatva गिफ्ट बॉक्स',
      description: 'पूर्ण संतुलन के लिए पाँचों तत्वों के चुने हुए लक्ज़री उत्पादों का क्यूरेटेड गिफ्ट बॉक्स।',
    },
  },
  profile: {
    header: 'प्रोफ़ाइल',
    loadingProfile: 'प्रोफ़ाइल लोड हो रही है...',
    loadingUserInfo: 'उपयोगकर्ता जानकारी लोड हो रही है...',
    labels: {
      name: 'नाम',
      email: 'ईमेल',
      firstName: 'पहला नाम',
      lastName: 'अंतिम नाम',
    },
  },
  quiz: {
    cta: 'अपना तत्व खोजें',
    ctaSubtitle: '5 प्रश्नों के माध्यम से अपने त्वचा के लिए सही तत्व जानें।',
    title: 'अपना तत्व खोजें',
    subtitle: '5 सवालों के जवाब दें और हम आपकी त्वचा के लिए सही तत्व खोजेंगे।',
    step: 'चरण',
    of: 'का',
    next: 'अगला',
    back: 'वापस',
    submit: 'मेरा तत्व जानें',
    loading: 'तत्वों को पढ़ा जा रहा है…',
    error: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
    questions: {
      skinType: { label: 'आपकी त्वचा का प्रकार क्या है?', options: { dry: 'शुष्क', oily: 'तैलीय', combination: 'मिश्रित', sensitive: 'संवेदनशील', normal: 'सामान्य' } },
      climate: { label: 'आपका मौसम कैसा है?', options: { hot_humid: 'गर्म और आर्द्र', dry_arid: 'शुष्क और रूखा', cold: 'ठंडा', temperate: 'समशीतोष्ण' } },
      concern: { label: 'आपकी मुख्य त्वचा चिंता क्या है?', options: { hydration: 'नमी', acne: 'मुहांसे', anti_aging: 'एंटी-एजिंग', glow: 'चमक', soothing: 'शांति' } },
      texture: { label: 'आप कौन सी बनावट पसंद करते हैं?', options: { rich: 'समृद्ध और क्रीमी', light: 'हल्का', solid: 'ठोस बार', none: 'कोई प्राथमिकता नहीं' } },
      fragrance: { label: 'कौन सी सुगंध आपको आकर्षित करती है?', options: { earthy: 'मिट्टी जैसी', fresh: 'ताज़ा और फूलों जैसी', citrus: 'खट्टे फलों जैसी', unscented: 'बिना सुगंध' } },
    },
    result: {
      title: 'आपका तत्व है',
      secondary: 'और थोड़ा',
      rationale: 'यह आपके लिए क्यों सही है',
      recommendedProducts: 'आपके लिए चुने गए उत्पाद',
      addSet: 'अनुशंसित सेट कार्ट में जोड़ें',
      retake: 'फिर से प्रयास करें',
      shopAll: 'सभी तत्व देखें',
      elements: { earth: 'पृथ्वी', water: 'जल', fire: 'अग्नि', air: 'वायु', ether: 'आकाश' },
      elementDescriptions: { earth: 'स्थिर · पोषक · गहरा', water: 'जलयोजित · शीतल · कोमल', fire: 'शुद्धिकारक · ऊर्जावान · स्पष्ट', air: 'ताज़ा · हल्का · मुक्त', ether: 'संतुलित · सूक्ष्म · शुद्ध' },
    },
  },
  chat: {
    title: 'तत्व',
    subtitle: 'आपका तत्व गाइड',
    placeholder: 'कुछ भी पूछें…',
    send: 'भेजें',
    loading: 'सोच रहा हूँ…',
    error: 'तत्व तक नहीं पहुँच सका। कृपया पुनः प्रयास करें।',
    escalatePrompt: 'क्या आप चाहते हैं कि मैं सपोर्ट टिकट बनाऊं?',
    escalateYes: 'हाँ, कृपया',
    escalateNo: 'नहीं, धन्यवाद',
    ticketSuccess: 'सपोर्ट टिकट बन गया। हम 24 घंटे में वापस आएंगे।',
    ticketError: 'टिकट नहीं बन सका। हमें ईमेल करें।',
    emailPlaceholder: 'आपका ईमेल पता',
    openLabel: 'तत्व से चैट करें',
    closeLabel: 'चैट बंद करें',
  },
  admin: {
    // Dashboard
    dashboard: 'व्यवस्थापक डैशबोर्ड',
    dashboardSubtitle: 'अपने पंच तत्व संचालन प्रबंधित करें',
    totalRevenue: 'कुल राजस्व',
    totalOrders: 'कुल ऑर्डर',
    totalCustomers: 'कुल ग्राहक',
    pendingActions: 'लंबित कार्य',
    requiresAttention: 'ध्यान देने योग्य',
    thisMonth: 'इस महीने',
    allTime: 'सभी समय',
    isActive: 'सक्रिय',
    topProducts: 'शीर्ष उत्पाद',
    recentOrders: 'हाल के ऑर्डर',
    systemHealth: 'सिस्टम स्वास्थ्य',
    razorpay: 'Razorpay',
    database: 'डेटाबेस',

    // Navigation
    products: 'उत्पाद',
    orders: 'ऑर्डर',
    customers: 'ग्राहक',
    finance: 'वित्त',
    reconciliation: 'समन्वय',
    settings: 'सेटिंग्स',
    manage: 'प्रबंधित करें',

    // Products Page
    manageProducts: 'उत्पाद जोड़ें, संपादित करें, हटाएं और इन्वेंटरी प्रबंधित करें',
    manageYourInventory: 'अपनी उत्पाद इन्वेंटरी प्रबंधित करें',
    productName: 'उत्पाद का नाम',
    element: 'तत्व',
    price: 'कीमत',
    costPrice: 'लागत मूल्य',
    quantity: 'मात्रा',
    warehouseLocation: 'गोदाम स्थान',
    description: 'विवरण',
    imageUrl: 'छवि यूआरएल',
    allStatus: 'सभी स्थिति',
    active: 'सक्रिय',
    discontinued: 'बंद किया गया',
    draft: 'ड्राफ्ट',
    profit: 'लाभ मार्जिन',
    searchProducts: 'उत्पाद खोजें...',
    noProducts: 'कोई उत्पाद नहीं मिला',
    addProduct: '+ उत्पाद जोड़ें',
    editProduct: 'उत्पाद संपादित करें',
    addNewProduct: 'नया उत्पाद जोड़ें',
    actions: 'कार्य',
    edit: 'संपादित करें',
    delete: 'हटाएँ',
    cancel: 'रद्द करें',
    previous: 'पिछला',
    next: 'अगला',
    page: 'पृष्ठ',
    of: 'का',

    // Orders Page
    manageAllOrders: 'सभी ग्राहक ऑर्डर देखें और प्रबंधित करें',
    manageOrders: 'ऑर्डर ट्रैक करें, रिफंड प्रक्रिया करें, मैनुअल ऑर्डर बनाएं',
    orderId: 'ऑर्डर आईडी',
    customer: 'ग्राहक',
    amount: 'राशि',
    status: 'स्थिति',
    date: 'तारीख',
    searchOrders: 'ऑर्डर आईडी, ईमेल द्वारा खोजें...',
    noOrders: 'कोई ऑर्डर नहीं मिला',
    pendingPayment: 'भुगतान लंबित',
    confirmed: 'पुष्टि किए गए',
    shipped: 'भेजे गए',
    delivered: 'वितरित',
    cancelled: 'रद्द किए गए',
    refunded: 'वापसी किए गए',
    refund: 'रिफंड',
    refundOrder: 'ऑर्डर रिफंड करें',
    refundAmount: 'रिफंड राशि',
    maxRefund: 'अधिकतम',
    reason: 'कारण',
    selectReason: 'कारण चुनें',
    notes: 'नोट्स',
    processRefund: 'रिफंड प्रोसेस करें',

    // Customers Page
    manageAllCustomers: 'सभी ग्राहक खातों को देखें और प्रबंधित करें',
    manageCustomers: 'ग्राहक विवरण और ऑर्डर इतिहास देखें',
    email: 'ईमेल',
    phone: 'फोन',
    lastOrder: 'अंतिम ऑर्डर',
    view: 'देखें',
    searchCustomers: 'ईमेल, नाम, फोन द्वारा खोजें...',
    noCustomers: 'कोई ग्राहक नहीं मिला',
    customerInfo: 'ग्राहक जानकारी',
    createdAt: 'सदस्य बने हुए',
    lastLogin: 'अंतिम लॉगिन',
    totalSpent: 'कुल खर्च',
    avgOrderValue: 'औसत ऑर्डर',
    memberStatus: 'स्थिति',
    addresses: 'पते',
    orderHistory: 'ऑर्डर इतिहास',
    close: 'बंद करें',

    // Finance Page
    viewFinancialData: 'लेनदेन और वित्तीय रिपोर्ट ट्रैक करें',
    manageFinance: 'लेनदेन, P&L रिपोर्ट, लेखा देखें',
    netRevenue: 'शुद्ध राजस्व',
    afterRefunds: 'रिफंड के बाद',
    grossProfit: 'सकल लाभ',
    margin: 'मार्जिन',
    netProfit: 'शुद्ध लाभ',
    roi: 'आरओआई',
    topProductsByRevenue: 'राजस्व द्वारा शीर्ष उत्पाद',
    unitsSold: 'बिकी गई इकाइयाँ',
    transactionFilters: 'लेनदेन फ़िल्टर',
    dateFrom: 'से तारीख',
    dateTo: 'तक तारीख',
    successful: 'सफल',
    pending: 'लंबित',
    failed: 'विफल',
    type: 'प्रकार',
    searchTransactions: 'लेनदेन खोजें...',
    noTransactions: 'कोई लेनदेन नहीं मिला',

    // Reconciliation Page
    detectAndResolveIssues: 'इन्वेंटरी, भुगतान और ऑर्डर में विसंगतियों का पता लगाएं और समाधान करें',
    manageReconciliation: 'विसंगतियों का पता लगाएं और समाधान करें, ऑडिट चलाएं',
    openIssues: 'खुले मुद्दे',
    critical: 'गंभीर',
    warnings: 'चेतावनियां',
    info: 'जानकारी',
    allSeverity: 'सभी गंभीरता',
    noIssuesFound: 'कोई समस्या नहीं मिली',
    resolveMismatch: 'विसंगति समाधान करें',
    issue: 'समस्या',
    expected: 'अपेक्षित',
    actual: 'वास्तविक',
    difference: 'अंतर',
    detected: 'पाया गया',
    product: 'उत्पाद',
    resolve: 'समाधान करें',
    selectAction: 'कार्य चुनें',
    confirm: 'पुष्टि करें',
    resolved: 'समाधान किया गया',
    ignored: 'अनदेखा किया गया',

    // Admin User Management
    manageAdmins: 'व्यवस्थापकों का प्रबंधन करें',
    adminUsers: 'व्यवस्थापक उपयोगकर्ता',
    promoteUser: 'व्यवस्थापक में बढ़ावा दें',
    demoteUser: 'उपयोगकर्ता को कम करें',
    viewDetails: 'विवरण देखें',
    searchByEmail: 'ईमेल या नाम द्वारा खोजें...',
    filterByRole: 'भूमिका द्वारा फ़िल्टर करें',
    allRoles: 'सभी भूमिकाएं',
    roleAdmin: 'व्यवस्थापक',
    roleSuperadmin: 'महाव्यवस्थापक',
    dateAssigned: 'निर्दिष्ट तारीख',
    assignedBy: 'द्वारा सौंपा गया',
    confirmDemote: 'अवनति की पुष्टि करें',
    demoteWarning: 'इस उपयोगकर्ता को सभी व्यवस्थापक पहुंच और अनुमतियां खो जाएंगी। यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    noAdminsFound: 'कोई व्यवस्थापक उपयोगकर्ता नहीं मिला',
    selectTargetRole: 'लक्ष्य भूमिका चुनें',
    promoteReason: 'बढ़ावा देने का कारण (वैकल्पिक)',
    demoteReason: 'अवनति का कारण (वैकल्पिक)',
    statusHistory: 'स्थिति इतिहास',
    promotedOn: 'को बढ़ावा दिया गया',
    demotedOn: 'को कम किया गया',
    userNotFound: 'उपयोगकर्ता नहीं मिला',
    alreadyAdmin: 'यह उपयोगकर्ता पहले से ही व्यवस्थापक है',
    promoteSuccess: 'उपयोगकर्ता को सफलतापूर्वक बढ़ावा दिया गया',
    demoteSuccess: 'उपयोगकर्ता को सफलतापूर्वक कम किया गया',
    backToDashboard: '← डैशबोर्ड पर वापस जाएं',

    // Common
    loading: 'लोड हो रहा है...',
    error: 'लोड करने में त्रुटि',
    units: 'इकाइयाँ',
  },
  shipment: {
    paymentReceived: 'भुगतान प्राप्त हो गया!', // TODO: professional translation
    paymentFailed: 'भुगतान विफल',
    paymentFailedDesc: 'आपका भुगतान संसाधित नहीं हो सका। कृपया पुनः प्रयास करें।',
    retryPayment: 'पुनः भुगतान करें',
    creatingShipment: 'शिपमेंट बनाई जा रही है...',
    creatingShipmentDesc: 'हम आपका ऑर्डर शिपमेंट के लिए तैयार कर रहे हैं (आमतौर पर 5–30 सेकंड)।',
    checkingStatus: 'स्थिति जाँची जा रही है...',
    checkingStatusDesc: 'हमारे फुलफिलमेंट पार्टनर से सत्यापन हो रहा है। 5 मिनट में पूर्ण होगा।',
    delayedDesc: 'हम आपका शिपमेंट तैयार कर रहे हैं। धैर्य रखने के लिए धन्यवाद।',
    shipmentFailed: 'शिपमेंट निर्माण विफल',
    shipmentFailedDesc: 'आपका शिपमेंट अभी नहीं बनाया जा सका। हमारी टीम इसकी समीक्षा करेगी।',
    permanentFailed: 'ऑर्डर को ध्यान देने की आवश्यकता है',
    permanentFailedDesc: 'कई प्रयासों के बाद भी शिपमेंट नहीं बनाया जा सका। कृपया सहायता से संपर्क करें।',
    contactSupport: 'सहायता से संपर्क करें',
    shipmentCreated: 'आपका ऑर्डर भेज दिया गया!',
    shipmentCreatedDesc: 'आपका पैकेज रास्ते में है। नीचे ट्रैक करें।',
    awbCode: 'AWB कोड',
    courier: 'कूरियर',
    trackingStatus: 'स्थिति',
    viewTracking: 'रीयल-टाइम ट्रैकिंग देखें →',
    estimatedDelivery: 'अनुमानित डिलीवरी',
    inTransit: 'रास्ते में',
    inTransitDesc: 'आपका पैकेज आपके रास्ते पर है।',
    outForDelivery: 'डिलीवरी के लिए निकला',
    outForDeliveryDesc: 'आपका पैकेज आज पहुँचेगा!',
    delivered: 'डिलीवर हो गया!',
    deliveredDesc: 'आपका ऑर्डर डिलीवर हो गया। खरीदारी के लिए धन्यवाद!',
    trackOrder: 'ऑर्डर ट्रैक करें',
    shopAgain: 'फिर से खरीदें',
    orderConfirmedNote: 'भुगतान सत्यापित हो गया और आपका ऑर्डर पुष्टि हो गया है।',
    pollingNote: 'यह पृष्ठ स्वचालित रूप से अपडेट होता है — रिफ्रेश करने की आवश्यकता नहीं है।',
    retryShipment: 'शिपमेंट पुनः प्रयास करें',
  },
  orderConfirmation: {
    title: 'ऑर्डर पुष्टि हो गया!',
    subtitle: 'आपकी खरीदारी के लिए धन्यवाद।',
    orderId: 'ऑर्डर आईडी',
    orderDate: 'ऑर्डर तिथि',
    total: 'कुल राशि',
    items: 'सामान',
    shippingAddress: 'शिपिंग पता',
    priceSummary: 'मूल्य सारांश',
    subtotal: 'उप-कुल',
    shipping: 'शिपिंग',
    free: 'मुफ़्त',
    tax: 'कर (18% GST)',
    confirmationEmail: 'पुष्टि ईमेल',
    confirmationEmailDesc: 'पुष्टि ईमेल भेजा गया',
    whatsNext: 'आगे क्या?',
    orderConfirmedStep: 'ऑर्डर पुष्टि',
    preparingStep: 'तैयारी',
    shippedStep: 'भेजा गया',
    deliveredStep: 'डिलीवर',
    viewOrderHistory: 'ऑर्डर इतिहास देखें',
    continueShopping: 'खरीदारी जारी रखें',
    viewReceipt: 'रसीद देखें', // TODO: professional translation
    guestPrompt: 'यह ऑर्डर ट्रैक करने के लिए अकाउंट बनाएं', // TODO: professional translation
    guestPromptDesc: 'साइन अप करें और अपने ऑर्डर इतिहास, डिलीवरी ट्रैकिंग और वन-क्लिक रीऑर्डर का लाभ उठाएं।', // TODO: professional translation
    guestPromptCta: 'अकाउंट बनाएं', // TODO: professional translation
  },
  orderDetails: {
    title: 'ऑर्डर',
    orderedOn: 'ऑर्डर तिथि',
    orderTimeline: 'ऑर्डर टाइमलाइन',
    orderStatus: 'वर्तमान स्थिति',
    orderSummary: 'ऑर्डर सारांश',
    itemsOrdered: 'सामान',
    shippingAddress: 'शिपिंग पता',
    shipmentInfo: 'शिपमेंट जानकारी',
    awbCode: 'AWB कोड',
    courier: 'कूरियर',
    tracking: 'ट्रैकिंग',
    viewTracking: 'पैकेज ट्रैक करें',
    estDelivery: 'अनुमानित डिलीवरी',
    subtotal: 'उप-कुल',
    shipping: 'शिपिंग',
    free: 'मुफ़्त',
    tax: 'कर',
    total: 'कुल',
    printInvoice: 'चालान प्रिंट करें',
    viewReceipt: 'रसीद देखें', // TODO: professional translation
    reorder: 'पुनः ऑर्डर करें',
    helpSupport: 'सहायता और समर्थन',
    needHelp: 'अपने ऑर्डर में मदद चाहिए?',
    contactSupport: 'सहायता से संपर्क करें',
    backToOrders: 'ऑर्डर पर वापस जाएं',
    quantity: 'मात्रा',
    price: 'मूल्य',
    loadingOrder: 'ऑर्डर विवरण लोड हो रहा है...',
    orderNotFound: 'ऑर्डर नहीं मिला।',
    failedToLoad: 'ऑर्डर विवरण लोड करने में विफल।',
  },
  adminShipment: { // TODO: professional translation
    shipmentStatusCol: 'शिपमेंट',
    awbCol: 'AWB / कूरियर',
    filterAll: 'सभी शिपमेंट',
    filterProcessing: 'प्रोसेसिंग',
    filterRetrying: 'पुनः प्रयास',
    filterFailed: 'विफल',
    filterShipped: 'भेजा गया',
    filterNotStarted: 'शुरू नहीं',
    failedShipmentsAlert: 'विफल शिपमेंट — फ़िल्टर करने के लिए क्लिक करें',
    awbPending: 'लंबित',
    expandTitle: 'शिपमेंट विवरण देखें',
    retryButton: 'शिपमेंट पुनः प्रयास',
    retryButtonTitle: 'एडमिन क्यू के माध्यम से शिपमेंट निर्माण का जबरन पुनः प्रयास',
    retryInFlight: 'क्यू में…',
    retryQueuedToast: 'पुनः प्रयास क्यू किया गया — कुछ सेकंड में स्थिति अपडेट देखें।',
    retryModalTitle: 'शिपमेंट पुनः प्रयास',
    retryModalSubtitle: 'यह एक नया शिपमेंट निर्माण प्रयास क्यू करेगा। परिणाम async है — कुछ सेकंड में देखें।',
    retryOrderId: 'ऑर्डर ID',
    retryReason: 'पुनः प्रयास का कारण',
    optional: 'वैकल्पिक',
    retryReasonPlaceholder: 'जैसे पता सही हुआ, कूरियर समस्या हल हुई…',
    retryConfirm: 'पुनः प्रयास क्यू करें',
    retryInProgress: 'क्यू हो रहा है…',
    retryAsyncNote: '⚡ पुनः प्रयास async है — शिपमेंट निर्माण पृष्ठभूमि में होगा।',
    retryQueued: 'पुनः प्रयास सफलतापूर्वक क्यू किया गया।',
    retryAlreadyCreated: 'यह शिपमेंट पहले ही सफलतापूर्वक बनाया जा चुका है।',
    retryRateLimit: 'आपको रेट लिमिट किया जा रहा है। कृपया थोड़ी देर प्रतीक्षा करें।',
    retryServiceUnavailable: 'शिपमेंट सेवा अभी अनुपलब्ध है। बाद में पुनः प्रयास करें।',
    retryNotReady: 'ऑर्डर अभी पुनः प्रयास के लिए तैयार नहीं है।',
    retryError: 'पुनः प्रयास क्यू करने में विफल।',
    close: 'बंद करें',
    cancel: 'रद्द करें',
    detailSectionTitle: 'शिपमेंट विवरण',
    detailStatus: 'स्थिति',
    detailShipmentId: 'शिपमेंट ID',
    detailAwb: 'AWB कोड',
    detailCourier: 'कूरियर',
    detailTracking: 'ट्रैकिंग URL',
    trackLink: 'पैकेज ट्रैक करें',
    detailShippingStatus: 'शिपिंग स्थिति',
    detailEdd: 'अनुमानित डिलीवरी',
    detailAsyncNote: '⚡ शिपमेंट async बन रही है — पृष्ठभूमि कार्यकर्ता पूरा होने पर डेटा अपडेट होगा।',
    noShipmentData: 'अभी कोई शिपमेंट डेटा नहीं है।',
  },
  adminMonitor: { // TODO: professional translation
    title: 'शिपमेंट मॉनिटर',
    subtitle: 'रियल-टाइम ऑपरेशंस डैशबोर्ड — शिपमेंट समस्याएं पहचानें और ठीक करें',
    navTitle: 'शिपमेंट मॉनिटर',
    navDesc: 'रियल-टाइम शिपमेंट ऑपरेशंस — विफलताएं, अटके ऑर्डर, SLA उल्लंघन',
    metricProcessing: 'प्रोसेसिंग',
    metricRetrying: 'पुनः प्रयास',
    metricFailed: 'स्थायी विफल',
    metricCompleted: 'आज शिप',
    metricStuck: 'अटके (>10 मि)',
    metricSlaBreach: 'SLA उल्लंघन',
    alertsTitle: 'ध्यान चाहिए',
    alertStuck: 'अटका ऑर्डर',
    alertSla: 'SLA उल्लंघन',
    alertFailed: 'स्थायी विफलता',
    noAlerts: 'कोई गंभीर समस्या नहीं — सभी शिपमेंट ठीक हैं',
    filterAll: 'सभी',
    filterProcessing: 'प्रोसेसिंग',
    filterRetrying: 'पुनः प्रयास',
    filterFailed: 'विफल',
    filterShipped: 'शिप',
    filterStuck: 'अटके',
    filterSlaBreach: 'SLA उल्लंघन',
    filterNeedsAttention: 'ध्यान चाहिए',
    timeFilter1h: 'पिछला 1 घंटा',
    timeFilter24h: 'पिछले 24 घंटे',
    timeFilterAll: 'सभी समय',
    colOrderId: 'ऑर्डर ID',
    colCustomer: 'ग्राहक',
    colPayment: 'भुगतान',
    colShipment: 'शिपमेंट',
    colAwb: 'AWB',
    colFailureReason: 'विफलता कारण',
    colDuration: 'अवधि',
    colSla: 'SLA समयसीमा',
    colActions: 'कार्रवाई',
    awbPending: 'लंबित',
    noOrders: 'मौजूदा फ़िल्टर से कोई ऑर्डर नहीं मिला।',
    noShipmentData: 'शिपमेंट डेटा उपलब्ध नहीं।',
    detailTitle: 'पूर्ण शिपमेंट रिकॉर्ड',
    trackLink: 'ट्रैकिंग खोलें',
    autoRefresh: 'ऑटो-रिफ्रेश',
    autoRefreshOn: 'चालू',
    autoRefreshOff: 'बंद',
    lastUpdated: 'अंतिम अपडेट',
    manualRefresh: 'अभी रिफ्रेश करें',
    refreshing: 'रिफ्रेश हो रहा है…',
    actionRetry: 'पुनः प्रयास',
    actionDetails: 'विवरण',
    retryModalTitle: 'शिपमेंट पुनः प्रयास',
    retryModalSubtitle: 'नई शिपमेंट बनाने का प्रयास कतार में डालें (async — ~30 सेकंड में देखें)',
    retryOrderId: 'ऑर्डर ID',
    retryReason: 'पुनः प्रयास का कारण',
    optional: 'वैकल्पिक',
    retryReasonPlaceholder: 'उदा. पता सत्यापित, कूरियर समस्या हल…',
    retryConfirm: 'कतार में डालें',
    retryInProgress: 'डाल रहे हैं…',
    cancel: 'रद्द करें',
    close: 'बंद करें',
    retryQueued: 'पुनः प्रयास कतार में — कुछ सेकंड में रिफ्रेश करें।',
    retryQueuedToast: 'पुनः प्रयास कतार में — स्थिति देखने के लिए रिफ्रेश करें।',
    retryAlreadyCreated: 'शिपमेंट पहले ही बन चुकी है। नवीनतम स्थिति देखने के लिए रिफ्रेश करें।',
    retryRateLimit: 'रेट सीमित — पुनः प्रयास से पहले प्रतीक्षा करें।',
    retryServiceUnavailable: 'शिपमेंट सेवा अनुपलब्ध है। बाद में पुनः प्रयास करें।',
    retryError: 'पुनः प्रयास विफल। कृपया दोबारा कोशिश करें।',
    retryNotReady: 'ऑर्डर अभी पुनः प्रयास के लिए तैयार नहीं।',
    retryAsyncNote: '⚡ पुनः प्रयास async है — ऑर्डर 30 सेकंड में अपडेट होगा।',
  },
  reconciliationMonitor: { // TODO: professional translation
    title: 'समाधान मॉनिटर',
    subtitle: 'लाइव डेटा अखंडता डैशबोर्ड — भुगतान, ऑर्डर और शिपमेंट असंगतताओं का पता लगाएं',
    navTitle: 'समाधान मॉनिटर',
    navDesc: 'डेटा अखंडता की लाइव निगरानी — अनाथ भुगतान, रुके ऑर्डर, विफल समाधान',
    metricOrphaned: 'अनाथ भुगतान',
    metricOrphanedTitle: 'भुगतान हुआ पर शिपमेंट शुरू नहीं (>15 मिनट)',
    metricFailedReconciling: 'विफल समाधान',
    metricFailedReconcilingTitle: 'शिपमेंट निर्माण पुनः प्रयास जारी',
    metricPermanentFailed: 'स्थायी विफलता',
    metricPermanentFailedTitle: 'सभी पुनः प्रयास समाप्त',
    metricStuck: 'रुका हुआ (>10 मिनट)',
    metricStuckTitle: 'सीमा से अधिक प्रोसेसिंग समय',
    metricSlaBreach: 'SLA उल्लंघन',
    metricSlaBreachTitle: 'समयसीमा बीत गई, पूरा नहीं',
    metricReconciled: 'आज समाधान हुए',
    metricReconciledTitle: 'पिछले 24 घंटों में सफलतापूर्वक पूरे',
    alertsTitle: 'गंभीर समस्याएं — तत्काल ध्यान आवश्यक',
    noAlerts: 'कोई गंभीर डेटा अखंडता समस्या नहीं — सभी सिस्टम सुसंगत',
    alertsOverflow: '+{n} और — सभी देखने के लिए नीचे फ़िल्टर उपयोग करें',
    autoRefresh: 'ऑटो-रिफ्रेश',
    autoRefreshOn: 'चालू',
    autoRefreshOff: 'बंद',
    lastUpdated: 'अंतिम अपडेट',
    manualRefresh: 'अभी रिफ्रेश करें',
    refreshing: 'रिफ्रेश हो रहा है…',
    runReconciliation: 'समाधान चलाएं',
    reconRunning: 'चल रहा है…',
    reconciliationTriggered: '✓ समाधान प्रारंभ — परिणाम शीघ्र दिखेंगे',
    exportCsv: 'CSV निर्यात करें',
    actionView: 'देखें',
    actionRetry: 'पुनः प्रयास',
    actionReconcile: 'समाधान',
    filterLabel: 'फ़िल्टर:',
    filterAll: 'सभी',
    filterOrphaned: 'अनाथ भुगतान',
    filterFailedReconciling: 'पुनः प्रयास जारी',
    filterPermanentFailed: 'स्थायी विफलता',
    filterStuck: 'रुका हुआ',
    filterSlaBreach: 'SLA उल्लंघन',
    filterNeedsAttention: 'ध्यान चाहिए',
    timeFilter1h: 'पिछला 1 घंटा',
    timeFilter24h: 'पिछले 24 घंटे',
    timeFilterAll: 'सभी समय',
    colOrderId: 'ऑर्डर ID',
    colPayment: 'भुगतान',
    colShipment: 'शिपमेंट',
    colIssueType: 'समस्या प्रकार',
    colDuration: 'प्रोसेसिंग',
    colSla: 'SLA समयसीमा',
    colLastUpdated: 'अंतिम अपडेट',
    colActions: 'कार्रवाई',
    noOrders: 'वर्तमान फ़िल्टर से कोई ऑर्डर नहीं।',
    noShipmentData: 'कोई शिपमेंट डेटा उपलब्ध नहीं।',
    detailTitle: 'पूरा रिकॉर्ड',
    selectedOrders: 'ऑर्डर चयनित',
    bulkRetry: 'सभी चयनित पुनः प्रयास करें',
    bulkRetrying: 'कतार में डाल रहे हैं…',
    clearSelection: 'साफ़ करें',
    // Tabs
    tabHealth: '🟢 लाइव स्वास्थ्य', // TODO: professional translation
    tabMismatches: '🔎 बेमेल', // TODO: professional translation
  },
  receipt: {
    title: 'रसीद', // TODO: professional translation
    receiptNumber: 'रसीद नं.',
    issuedDate: 'जारी तिथि',
    orderId: 'ऑर्डर ID',
    customerInfo: 'ग्राहक',
    billingAddress: 'बिलिंग पता',
    orderItems: 'ऑर्डर आइटम',
    columnProduct: 'उत्पाद',
    columnQty: 'मात्रा',
    columnUnit: 'इकाई मूल्य',
    columnTotal: 'कुल',
    subtotal: 'उप-कुल',
    tax: 'कर',
    shipping: 'शिपिंग',
    total: 'कुल',
    free: 'निःशुल्क',
    paymentInfo: 'भुगतान',
    paymentMethod: 'विधि',
    paymentId: 'भुगतान ID',
    paymentStatus: 'स्थिति',
    paid: 'भुगतान हो गया',
    printReceipt: 'रसीद प्रिंट करें',
    downloadPdf: 'PDF डाउनलोड करें',
    backToOrder: 'ऑर्डर पर वापस',
    currency: '₹',
    loading: 'रसीद लोड हो रही है…', // TODO: professional translation
    errorTitle: 'रसीद लोड नहीं हो सकी', // TODO: professional translation
    errorNotFound: 'यह रसीद उपलब्ध नहीं है। हो सकता है ऑर्डर का भुगतान अभी नहीं हुआ हो।', // TODO: professional translation
    errorForbidden: 'आपके पास इस रसीद को देखने की अनुमति नहीं है।', // TODO: professional translation
    errorRateLimit: 'बहुत अधिक अनुरोध — कृपया कुछ देर रुककर पुनः प्रयास करें।', // TODO: professional translation
    errorGeneric: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।', // TODO: professional translation
    pdfError: 'PDF डाउनलोड विफल हुई। कृपया पुनः प्रयास करें।', // TODO: professional translation
    pdfRateLimit: 'बहुत अधिक अनुरोध — डाउनलोड से पहले थोड़ी देर प्रतीक्षा करें।', // TODO: professional translation
    tryAgain: 'पुनः प्रयास करें', // TODO: professional translation
  },
};

export default hi;
